import React, { useState, useEffect } from 'react';
import { InputRadio } from "./Components/InputRadio";
import { InputDropdown } from "./Components/InputDropdown";
import { page, page1, page3 } from "./questions";
import { StepBar } from "./Components/StepBar";
import { FormButton } from "./Components/FormButton";
import Page2 from './Components/Page2';
import { Helmet } from 'react-helmet';
import './App.css';
import HubspotForm from 'react-hubspot-form';
import { logFormError } from './utils/errorLogger';

function App() {

    const [formState, setFormState] = useState(1);
    const [userType, setUserType] = useState("");
    const [currentlyIn, setCurrentlyIn] = useState("");
    const [graduationYear, setGraduationYear] = useState("");
    const [indexOfFirst, setIndexOfFirst] = useState(-1);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [helpText, setHelpText] = useState("");
    const [highschool, setHighschool] = useState("");
    const [firstNameSub, setFirstNameSub] = useState("");
    const [lastNameSub, setLastNameSub] = useState("");
    const [emailSub, setEmailSub] = useState("");
    const [phoneSub, setPhoneSub] = useState("");
    const [hubCookie, setHubCookie] = useState('');
    const [pageTitle, setPageTitle] = useState('');
    const [pageUrl, setPageUrl] = useState('');
    const [irClickId, setIrClickId] = useState('');
    const [customCampaignName, setCustomCampaignName] = useState('');
    const [applyingToGradProgram, setApplyingToGradProgram] = useState("");
    const [partnerid, setPartnerid] = useState('');

    async function validateInput() {
        try {
            if (formState === 1) {
                if (userType === 'Student' || userType === 'Graduate School Applicant') {
                    if (!currentlyIn.trim()) {
                        await logFormError(
                            new Error("Missing current status"),
                            { userType, currentlyIn },
                            { validationType: "current_status", formState }
                        );
                        setErrorMessage('Please select your current status');
                        return false;
                    }
                }
            }
            return true;
        } catch (error) {
            await logFormError(error, 
                { formState, userType },
                { validationType: "general_validation" }
            );
            return false;
        }
    }

    async function goToNext() {
        const valid = await validateInput();
        if (valid) {
            setErrorMessage('');
            if (formState === 1) {
                setFormState(formState + 1);
            }
        }
        // The error message is now set in validateInput, so we don't need to set it here
    }

useEffect(() => {
    // change height
    if (formState===1) {
        // setHeight('100%', '165%'); //2 values: desktop and mobile
        // setHeight('510px');
        setHeight('page1');
    } else if (formState===2) {
        // if student currently in college -> short
        // if school admin -> short
        const case_1 = userType==='Student' && currentlyIn.includes('college');
        const case_2 = userType?.includes('admin');
        if(case_1 || case_2) {
            // setHeight('150%', '300%');
            // setHeight('925px');
            setHeight('page2-short');
        }
        // if parent -> tall
        // if student currently in high school, middle school, gap -> tall
        // if employer -> tall
        // if other -> tall
        else {
            // setHeight('190%', '350%');
            // setHeight('1200px');
            setHeight('page2-tall');
        }
    } else if (formState===3) {
        // setHeight('160%', '320%')
        // setHeight('1025px');
        setHeight('page3');
    }
}, [formState])

  const goToPrevious = () => {
      setFormState(formState-1);
      setErrorMessage("");
  }

  useEffect(() => {
      setErrorMessage("");
    }, [userType, currentlyIn]);


    useEffect(() => {
        try {
            function getParamValue(paramName)
            {
                // Get the URL and remove any fragment identifier
                var fullUrl = window.location.href;
                var urlWithoutHash = fullUrl.split('#')[0];
                
                // Extract just the query string
                var queryString = urlWithoutHash.split('?')[1] || '';
                
                // Parse the parameters
                var qArray = queryString.split('&');
                for (var i = 0; i < qArray.length; i++)
                {
                    var pArr = qArray[i].split('=');
                    if (pArr[0] === paramName)
                        return pArr[1]; // return value
                }
                return ''; // Return empty string if parameter not found
            }

            // get params from url
            var hubspotutk = getParamValue('hub_cookie');
            var page_title = getParamValue('page_title');
            var page_url = getParamValue('page_url');
            
            if(page_title?.includes('%')) {
                page_title = decodeURI(page_title);
            }
            if(!page_title) {
                page_title = window.document.title;
            }
            if(!page_url) {
                page_url = window.location.href;
            }
            var ir_click_id;
            ir_click_id = sessionStorage.getItem('irclickid'); //first try to get it from sessionStorage
            if(ir_click_id) {
                setIrClickId(ir_click_id);
            } else {
                // if it doesn't exist in sessionStorage, get it from url param
                ir_click_id = getParamValue('irclickid');
                setIrClickId(ir_click_id);
            }

            // Similar handling for custom_campaign_name
            var custom_campaign_name;
            custom_campaign_name = sessionStorage.getItem('custom_campaign_name');
            if(custom_campaign_name) {
                setCustomCampaignName(custom_campaign_name);
            } else {
                custom_campaign_name = getParamValue('custom_campaign_name');
                setCustomCampaignName(custom_campaign_name);
            }

            // Similar handling for partnerid
            var partner_id;
            partner_id = sessionStorage.getItem('partnerid');
            if(partner_id) {
                setPartnerid(partner_id);
            } else {
                partner_id = getParamValue('partnerid');
                setPartnerid(partner_id);
            }

            setHubCookie(hubspotutk);
            setPageTitle(page_title);
            setPageUrl(page_url);

        } catch (error) {
            logFormError(error, {
                context: "URL parameter loading failure",
                url: window.location.href,
                rawParams: window.location.search
            });
            // Set default values in case of error
            setPageTitle(window.document.title);
            setPageUrl(window.location.href);
        }
    }, [])

    function setHeight(value, mobile_value) {
        // if(isMobile()) {
        //     window.parent.postMessage(["setHeight", mobile_value], "*");
        // } else {
        //     window.parent.postMessage(["setHeight", value], "*");
        // }
        window.parent.postMessage(["setHeight", value], "*");
    }

    function isMobile() {
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    };

  return (
    <div className="bg-white rounded-[20px]">
        <div className="py-8 lg:py-16 px-4 mx-auto max-w-screen-md">
            {page.header.length > 0
            ? <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-center text-gray-900">{page.header}</h2>
            : null }
            {page.subheader.length > 0
            ? <p className="mb-8 lg:mb-16 font-light text-center text-gray-500 sm:text-xl">{page.subheader}</p>
            : null }

            <StepBar formState={formState} totalPages={page.total_pages}/>

            <div className='hidden'>
            <HubspotForm
                portalId="20025183"
                formId="f89dd5c0-ac2e-4b74-adad-bdcd59ef9a0a"
                onSubmit={() => console.log('Submit!')}
                loading={<div>Loading...</div>}
                />
            </div>

            <form className="hs-form-private space-y-4">
                {
                    formState === 1 ?
                    <div>
        <InputRadio
            question={page1.q1}
            setState={setUserType}
            indexOfFirst={indexOfFirst}
            setIndexOfFirst={setIndexOfFirst}
        />
        {(userType === "Student" || userType === "Graduate School Applicant") && (
            <InputDropdown
                question={{
                    ...page1.q2,
                    label: userType === "Graduate School Applicant" ? "I am interested in applying to" : "Currently",
                    options: userType === "Graduate School Applicant" ? page1.q2.options_grad : page1.q2.options,
                }}
                setState={setCurrentlyIn}
                required={true}
                default_value={currentlyIn}
            />
        )}
    </div>
    :
    <div className='hidden'>
        <InputRadio
            question={page1.q1}
            setState={setUserType}
            indexOfFirst={indexOfFirst}
            setIndexOfFirst={setIndexOfFirst}
        />
        {(userType === "Student" || userType === "Graduate School Applicant") && (
            <InputDropdown
                question={{
                    ...page1.q2,
                    label: userType === "Graduate School Applicant" ? "I am interested in applying to" : "Currently",
                    options: userType === "Graduate School Applicant" ? page1.q2.options_grad : page1.q2.options,
                }}
                setState={setCurrentlyIn}
                required={true}
                default_value={currentlyIn}
            />
        )}
    </div>
}

                {
                    formState === 2 ?
                    <Page2
                        userType={userType}
                        currentlyIn={currentlyIn}
                        graduationYear={graduationYear}
                        setGraduationYear={setGraduationYear}
                        firstName={firstName}
                        setFirstName={setFirstName}
                        lastName={lastName}
                        setLastName={setLastName}
                        email={email}
                        setEmail={setEmail}
                        phone={phone}
                        setPhone={setPhone}
                        helpText={helpText}
                        setHelpText={setHelpText}
                        highschool={highschool}
                        setHighschool={setHighschool}
                        errorMessage={errorMessage}
                        setErrorMessage={setErrorMessage}
                        pageTitle={pageTitle}
                        pageUrl={pageUrl}
                        hubCookie={hubCookie}
                        setFormState={setFormState}
                        formState={formState}
                        firstNameSub={firstNameSub}
                        setFirstNameSub={setFirstNameSub}
                        lastNameSub={lastNameSub}
                        setLastNameSub={setLastNameSub}
                        emailSub={emailSub}
                        setEmailSub={setEmailSub}
                        phoneSub={phoneSub}
                        setPhoneSub={setPhoneSub}
                        goToPrevious={goToPrevious}
                        irClickId={irClickId}
                        customCampaignName={customCampaignName}
                        partnerid={partnerid}
                        applyingToGradProgram={applyingToGradProgram}
                        setApplyingToGradProgram={setApplyingToGradProgram}
                    />
                    : null
                }

{
    formState === 3 ?
    <div className={formState !== 3 ? 'hidden' : 'block'}>
        <Helmet>
            <script type="text/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>
        </Helmet>
        <h3 className='py-2 ml-[4px] text-3xl font-bold'>{page3.headline}</h3>
        <div className="meetings-iframe-container" data-src={
            userType === 'Graduate School Applicant'
                ? "https://meetings.hubspot.com/initial-consultations/graduate-admissions-counseling-scheduling-calendar?embed=true"
                : currentlyIn.includes('transfer')
                    ? "https://meetings.hubspot.com/kayleigh-o-keefe/initial-consultation-with-prepory-transfer?embed=true"
                    : "https://meetings.hubspot.com/prepory/initial-consultation-with-prepory-round-robin?embed=true"
        }></div>
    </div>
    : null
}
<div className="!mt-5">
            {
                (formState === page.total_pages)
                ? <FormButton cta="Back" clickAction={goToPrevious} type="secondary" /> // page 3, show back button only
                : (formState === 2)
                ? null // page 2, show nothing
                : <FormButton cta="Next" clickAction={goToNext} type="default" stype="secondary"/> // page 1, show regular next button
            }
            </div>

            {
                errorMessage.length > 0
                ? <p className='text-red-600 text-sm font-bold'>{errorMessage}</p>
                : null
            }

            {formState < 3 ?
            <div>
                <p className='text-sm text-slate-400'>* required</p>
            </div>
            : null
            }
        </form>
    </div>
  </div>
  
);
}

export default App;
